import React, { useEffect, useMemo } from 'react';
import { Container, Col, Row } from 'reactstrap';
import Comments from './Comments';
import Summary from './Summary';
import TimeTracking from "./TimeTracking";
import BreadCrumb from '../../../../../Components/Common/BreadCrumb';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getActivity } from '../../../../../slices/thunks';
import OPlaceholder from '../../../../../Components/OElements/OPlaceholder';
import CardWithError from '../../../../../Components/Common/CardWithError';
import CardWithoutData from '../../../../../Components/Common/CardWithoutData';
import { cleanItemActivityDetail } from '../../../../../slices/activity/reducer';

const TaskDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const breadcrumbLinks = useMemo(() => [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Establecimiento' },
        { to: '#', label: 'Ciclo Productivo' },
        { to: '#', label: 'Actividades' }
    ], []);

    const { data, isLoading, isError } = useSelector(state => ({
        data: state.Activities.itemActivityDetail,
        isLoading: state.Activities.isLoading,
        isError: state.Activities.isError,
    }));

    useEffect(() => {
        if (id) {
            dispatch(getActivity(id));
        }
    }, [id, dispatch]);

    const renderContent = (Component) => {
        if (isLoading) return <OPlaceholder />;
        if (isError) return <CardWithError />;
        if (data) return <Component data={data} />;
        return <CardWithoutData />;
    };

    useEffect(() => {
        return () => {
            dispatch(cleanItemActivityDetail());
        }
    }, [])

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Actividad" links={breadcrumbLinks} />
                <Row>
                    <Col xxl={3}>
                        {renderContent(TimeTracking)}
                    </Col>
                    <Col xxl={9}>
                        {renderContent(Summary)}
                        {renderContent(Comments)}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TaskDetails;
